import { memo } from 'react';

import useIsPortrait from '../../../../hooks/useIsPortrait';
import {
  CurrencyType,
  getCurrencyDetails,
} from '../../../../constants/currencies';
import { PngIcon } from '../../PngIcon';
import './GeneralModal.css';

export enum GeneralModalYesButtonVariant {
  Cyan = 'cyan',
  Red = 'red',
  WEABlue = 'WEABlue',
  cyanDisabled = 'cyanDisabled',
  WEAblueDisabled = 'WEAblueDisabled',
}

export enum GeneralModalNoButtonVariant {
  Cyan = 'cyan',
  Gray = 'gray',
  WEABlue = 'WEABlue',
}

interface ButtonSetting {
  noText: string;
  yesText?: string;
  noVariant: GeneralModalNoButtonVariant;
  yesVariant?: GeneralModalYesButtonVariant;
  yesFee?: {
    type: CurrencyType;
    amount: number;
  };
}

type GeneralModalProps = {
  title?: string;
  warning?: string;
  subTitle?: string;
  hasDivider?: boolean;
  content?: string;
  children?: React.ReactNode;
  buttonSetting?: ButtonSetting;
  onYes?: () => void;
  onClose: () => void;
  isYesNo?: boolean;
};

export const GeneralModal = memo(
  ({
    title,
    warning,
    subTitle,
    hasDivider,
    content,
    children,
    buttonSetting,
    onYes,
    onClose,
    isYesNo,
  }: GeneralModalProps) => {
    const isPortrait = useIsPortrait();

    const makePrimaryButtonLabel = () => {
      if (!buttonSetting?.yesFee) {
        return <p className="yesButton-text">{buttonSetting?.yesText}</p>;
      }

      const { icon } = getCurrencyDetails(buttonSetting.yesFee.type);

      return (
        <>
          {buttonSetting?.yesText ? (
            <p className="yesButton-text">{buttonSetting?.yesText}</p>
          ) : null}
          <div className={'yes-fee-container'}>
            <PngIcon name={icon} width={24} height={24} />
            <span>{buttonSetting.yesFee.amount}</span>
          </div>
        </>
      );
    };

    return (
      <div className="general-modal">
        <div className={`modal-container  ${isPortrait ? 'isPortrait' : ''}`}>
          <div className="modal-text-container">
            {title && (
              <div className="title-container">
                <p className="title">{title}</p>
              </div>
            )}

            {warning && (
              <div className="warning-container">
                <p className="warning">{warning}</p>
              </div>
            )}

            {subTitle && (
              <div className="subTitle-container">
                <p className="subTitle">{subTitle}</p>
              </div>
            )}

            {hasDivider && <hr />}

            {content && (
              <div className="content-container">
                <p className="content">{content}</p>
              </div>
            )}

            {children && <div className="children-container">{children}</div>}
          </div>

          {buttonSetting && (
            <div className="button-container">
              <div
                className={`noButton-container ${buttonSetting.noVariant} button-container`}
                onClick={onClose}
              >
                <p className={`noButton-text ${buttonSetting.noVariant}`}>
                  {buttonSetting.noText}
                </p>
              </div>

              {isYesNo && (
                <div
                  className={`yesButton-container ${buttonSetting.yesVariant} button-container`}
                  onClick={onYes}
                >
                  {makePrimaryButtonLabel()}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  },
);
